import commonActions from "../common/actions";
import feedbackActions from "./actions";
import axios from "axios";
import { takeEvery, call, all, put, delay } from "redux-saga/effects";
import { API_URL } from "../../utils/constants";
import {
  handleDecodeJSON,
  handleEncodeJson,
} from "../../utils/encodeDecodeJson";
import Cookies from "js-cookie";
import { EncryptObjectFunction } from "../../utils/cryptoFunction";

const feedbackSaga = function* () {
  yield all([
    yield takeEvery(
      feedbackActions.GET_FEEDBACK_QUESTIONS,
      getFeedbackQuestions
    ),
    yield takeEvery(
      feedbackActions.GET_FEEDBACK_SUBMIT_ANSWER,
      submitAndGetFeedbackQuestion
    ),
    yield takeEvery(feedbackActions.AUDIT_LOG_FEEDBACK, auditLogFeedback),
  ]);
};

const getFeedbackQuestions = function* (data) {
  const { payload } = data;
  const { navigate } = payload;
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/api/exam/start-feedback`, payload.data)
    );
    const decodedResult = yield call(() =>
      handleDecodeJSON({ decodeJSON: result?.data?.data })
    );
    yield put({
      type: feedbackActions.SET_FEEDBACK_QUESTIONS,
      payload: result?.data?.code === "OK" ? decodedResult : [],
    });
    if (result?.data?.code === "OK") {
      const queryParams = {
        SrNo: decodedResult?.questionData?.srNo,
        lang: `${payload?.formData?.language}`,
        img: `${payload?.formData?.imageSize}`,
        ans: decodedResult?.questionData?.selectedAnswer,
      };
      const encryptedParans = EncryptObjectFunction(queryParams);
      navigate(
        `/${Cookies.get("test_engine_project")}/feedback?qNo=${encryptedParans}`
      );
      //   yield put({
      //     type: commonActions.SET_ALERT,
      //     payload: {
      //       status: result?.data?.code === "OK" ? "success" : "failed",
      //       show: true,
      //       message: result?.data?.code === "OK" ? "Exam Started" : "Failed",
      //     },
      //   });
      //   yield delay(2000);
      //   yield put({
      //     type: commonActions.SET_ALERT,
      //     payload: {
      //       status: null,
      //       show: false,
      //       message: null,
      //     },
      //   });
    }
  } catch (err) {
    console.log(err);
  }
};

const submitAndGetFeedbackQuestion = function* (data) {
  const { payload } = data;
  const { navigate, handleSelectedValue, queryParams } = payload;
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/api/exam/submit-feedback-answer`, payload.data)
    );
    const decodedResult = yield call(() =>
      handleDecodeJSON({ decodeJSON: result?.data?.data })
    );
    
    yield put({
      type: feedbackActions.SET_FEEDBACK_QUESTIONS,
      payload: result?.data?.code === "OK" ? decodedResult : [],
    });
    if (result?.data?.code === "OK") {
      const searchParams = {
        ...queryParams,
        selectedAnswer: decodedResult?.questionData?.selectedAnswer,
      };
      const encryptedParans = EncryptObjectFunction(searchParams);
      navigate(
        `/${Cookies.get("test_engine_project")}/feedback?qNo=${encryptedParans}`
      );
      handleSelectedValue("");
    }
  } catch (err) {
    console.log(err);
  }
};

const auditLogFeedback = function* (data) {
  const { payload } = data;
  try {
    const encodeData = yield call(() =>
      handleEncodeJson({ encodeJSON: payload.data, wrapKey: true })
    );
    const result = yield call(() =>
      axios.post(`${API_URL}/api/exam/feedback-question-audit-log`, encodeData)
    );
    console.log(result);
  } catch (err) {
    console.log(err);
  }
};

export default feedbackSaga;
